<template>
  <div>
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div class="map">
      <div class="main-content1 pc">
        <div style="display: flex; padding: 100px 0">
          <div style="width: 200px; margin-right: 60px">
            <div style="background: #bfb097; padding: 20px 15px">
              <div style="background: #f6efe7; padding: 10px 20px">
                <div
                  :class="type === 1 ? 'selectBar' : 'no-selectBar'"
                  @click="handleSelect(1)"
                >
                  电子地图
                </div>
                <div
                  :class="type === 2 ? 'selectBar' : 'no-selectBar'"
                  @click="handleSelect(2)"
                >
                  招聘信息
                </div>
                <div
                  :class="type === 3 ? 'selectBar' : 'no-selectBar'"
                  @click="handleSelect(3)"
                >
                  在线留言
                </div>
                <div
                  :class="type === 4 ? 'selectBar' : 'no-selectBar'"
                  @click="handleSelect(4)"
                >
                  调查问卷
                </div>
              </div>
            </div>
            <div
              class="flex-center"
              style="font-weight: bold; margin-top: 20px"
            >
              <img
                src="../assets/icon1.png"
                alt=""
                style="width: 36px; margin-right: 16px"
              />
              <div>
                <div style="font-size: 16px">{{ basicInfo.phone }}</div>
                <div style="font-size: 12px">咨询热线</div>
              </div>
            </div>
            <div
              class="flex-center"
              style="font-weight: bold; margin-top: 20px"
            >
              <img
                src="../assets/icon2.png"
                alt=""
                style="width: 36px; margin-right: 16px"
              />
              <div>
                <div style="font-size: 16px">{{ basicInfo.service_time }}</div>
                <div style="font-size: 12px">特殊节假日除外</div>
              </div>
            </div>
            <div
              class="flex-center"
              style="font-weight: bold; margin-top: 20px"
            >
              <img
                src="../assets/icon3.png"
                alt=""
                style="width: 32px; margin-right: 16px"
              />
              <div>
                <div style="font-size: 14px">
                  {{ basicInfo.hospital_address }}
                </div>
              </div>
            </div>
            <div
              class="flex-center"
              style="margin-top: 60px; justify-content: center"
            >
              <img
                src="../assets/zyys.png"
                alt=""
                style="width: calc(40% - 8px); margin-right: 16px"
              />
              <img
                src="../assets/zywh.png"
                alt=""
                style="width: calc(40% - 8px)"
              />
            </div>
          </div>
          <div class="text-content" style="" v-if="type === 1">
            <div style="font-size: 26px; color: #333" class="flex-center">
              <img
                src="../assets/icon101.png"
                alt=""
                style="width: 50px; margin-right: 10px"
              />{{ basicInfo.name }}
            </div>
            <div
              style="
                margin-top: 10px;
                font-size: 16px;
                line-height: 26px;
                padding: 20px 5px 0 0;
                border-top: 1px solid #e5e5e5;
              "
              v-html="basicInfo.hospital_introduce"
            ></div>
            <div style="font-size: 22px; margin-top: 20px; color: #333">
              联系方式
            </div>
            <div style="font-size: 18px; margin-top: 10px">
              {{ basicInfo.phone }}
            </div>
            <div style="display: flex; margin-top: 8px">
              <div style="margin-right: 10px">地址:</div>
              <div>
                <div>{{ basicInfo.hospital_address }}</div>
                <div
                  style="font-size: 13px; margin-top: 10px"
                  v-html="basicInfo.hospital_address_way"
                ></div>
              </div>
            </div>
            <div style="font-size: 22px; margin: 30px 0 20px; color: #333">
              电子地图
            </div>
            <baidu-map
              :center="center"
              :zoom="18"
              style="height: 300px"
              :scroll-wheel-zoom="true"
            >
              <BmMarker
                :position="center"
                title="东莞黄家圣幸中医医院"
                @click="infoWindowOpen"
              >
                <bm-info-window
                  :show="show"
                  @close="infoWindowClose"
                  @open="infoWindowOpen"
                  style="font-size: 14px"
                  >东莞黄家圣幸中医医院</bm-info-window
                >
              </BmMarker>
            </baidu-map>
          </div>
          <div class="text-content" v-if="type === 2">
            <div style="line-height: 30px; padding: 0; border-radius: 10px">
              <div class="flex-center" style="padding: 10px 0">
                <img
                  src="../assets/icon41.png"
                  alt=""
                  style="width: 40px; margin-right: 20px"
                />
                <div style="font-size: 26px; color: #333">招聘信息</div>
              </div>
              <el-collapse v-model="activeNames" accordion>
                <el-collapse-item
                  v-for="(item, index) of jobList"
                  :name="index"
                  :key="index"
                >
                  <template slot="title">
                    <div
                      class="flex-center"
                      style="width: 100%; position: relative; padding: 5px 0"
                    >
                      <div style="font-size: 18px; font-weight: bold">
                        {{ item.title }}
                      </div>
                      <div style="height: 1px; background: #000; flex: 1"></div>
                      <div style="position: absolute; top: -10px; right: 10px">
                        {{ item.releasetime_text }}
                      </div>
                    </div>
                  </template>
                  <div
                    style="margin-top: 10px; padding: 0 20px"
                    v-html="item.content"
                  ></div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <div class="text-content" v-if="type === 3">
            <div class="flex-center" style="padding: 10px 0">
              <img
                src="../assets/icon51.png"
                alt=""
                style="width: 40px; margin-right: 20px"
              />
              <div style="font-size: 26px; color: #333">在线留言</div>
            </div>
            <div
              style="
                padding-left: 60px;
                font-size: 14px;
                border-top: 1px solid #e5e5e5;
                padding-top: 20px;
              "
            >
              感谢您写下宝贵留言，黄家圣幸中医医院全心为您服务！
              <div class="flex-center" style="margin-top: 30px">
                <el-input
                  v-model="form.name"
                  style="width: 50%"
                  placeholder="您的姓名"
                >
                  <template slot="prepend">
                    <img
                      src="../assets/icon6.png"
                      style="width: 15px; background: #fff"
                      alt=""
                    />
                  </template>
                </el-input>
              </div>
              <div class="flex-center" style="margin-top: 30px">
                <el-input
                  v-model="form.mobile"
                  style="width: 50%"
                  placeholder="您的联系方式"
                >
                  <template slot="prepend">
                    <img
                      src="../assets/icon7.png"
                      style="width: 15px; background: #fff"
                      alt=""
                    />
                  </template>
                </el-input>
              </div>
              <div class="flex-center" style="margin-top: 30px">
                <el-input
                  v-model="form.email"
                  style="width: 50%"
                  placeholder="您的邮箱"
                >
                  <template slot="prepend">
                    <img
                      src="../assets/icon8.png"
                      style="width: 15px; background: #fff"
                      alt=""
                    />
                  </template>
                </el-input>
              </div>
              <div style="margin-top: 30px">
                <el-input
                  type="textarea"
                  v-model="form.content"
                  style="width: 80%"
                  placeholder="您的留言"
                  :rows="4"
                ></el-input>
              </div>
              <div class="flex-center">
                <verification
                  :key="verificationkey2"
                  ref="verification"
                  style="margin-top: 20px; width: 300px"
                ></verification>
              </div>
              <el-button
                style="
                  background: #439392;
                  color: #fff;
                  font-size: 16px;
                  height: 40px;
                  line-height: 40px;
                  width: 130px;
                  border-radius: 0;
                  padding: 0;
                  margin-top: 30px;
                "
                @click="checkSubmit('pc')"
                >提 交</el-button
              >
            </div>
          </div>
          <div class="text-content" v-if="type === 4">
            <div
              class="flex-center"
              style="border-bottom: 1px solid #e5e5e5; padding-bottom: 10px"
            >
              <img
                src="../assets/icon91.png"
                alt=""
                style="width: 50px; margin-right: 20px"
              />
              <div style="">
                <div style="font-size: 28px; color: #333">满意度调查</div>
                <div style="font-size: 14px; margin-top: 10px">
                  您所给出的任何评价，都是我们日后在工作过程中最宝贵的意见，感谢您的支持！
                </div>
              </div>
            </div>
            <div
              class="question"
              v-for="(item, index) of question"
              :key="index"
            >
              <div v-if="item.type === '1'">
                <!-- 单选 -->
                <div class="questionTitle">
                  {{ index + 1 }}、{{ item.title }}
                </div>
                <div class="questionA">
                  <div v-for="(item1, indexs) of item.json" :key="indexs">
                    <el-radio
                      v-model="item.value"
                      :label="item1.title"
                      text-color="#a6937c"
                      >{{ item1.content }}</el-radio
                    >
                  </div>
                </div>
              </div>
              <div v-if="item.type === '2'">
                <div class="questionTitle" style="margin-bottom: 10px">
                  {{ index + 1 }}、{{ item.title }}
                </div>
                <!-- 多选 -->
                <el-checkbox-group v-model="item.value">
                  <el-checkbox
                    v-for="(item1, index) of item.json"
                    :label="item1.title"
                    :key="index"
                    >{{ item1.content }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div v-if="item.type === '3'">
                <div class="questionTitle" style="margin-bottom: 10px">
                  {{ index + 1 }}、{{ item.title }}
                </div>
                <!-- 文本 -->
                <el-input type="textarea" v-model="item.value"></el-input>
              </div>
            </div>
            <div class="question flex-center">
              <verification
                :key="verificationkey1"
                ref="verification"
                style="margin-top: 20px; width: 300px"
              ></verification>
            </div>

            <el-button
              style="
                background: #439392;
                color: #fff;
                font-size: 16px;
                height: 40px;
                line-height: 40px;
                width: 130px;
                margin-left: 80px;
                border-radius: 0;
                padding: 0;
                margin-top: 30px;
              "
              @click="addQuestionSubmit(`pc`)"
              >提 交</el-button
            >
          </div>
        </div>
      </div>
      <div class="mobile main-content1" style="padding-top: 0.1rem">
        <div class="big-title" style="">
          <div class="big-name">联系我们</div>
          <div class="big-eng">
            <span class="line-left"></span>
            <span class="txt">contact us</span>
            <span class="line-right"></span>
          </div>
        </div>
        <div class="" style="padding: 0.2rem 0.13rem; position: relative;border-bottom:5px solid #f3f3f3;">
          <div
            style="float: left; width: 0.15rem; margin-top: 0.06rem"
            @click="last"
          >
            <img src="../assets/mobile/left.png" alt="" style="width: 100%" />
          </div>
          <van-tabs
            style="width: calc(100% - 0.3rem); float: left"
            v-model="active"
            type="card"
            swipeable
            color="#f3f3f3"
            background="#f3f3f3"
            :swipe-threshold="3"
            @click="switchTab"
          >
            <van-tab
              v-for="(item, index) of titleList"
              :key="index"
              :title="item.main_title"
              :title-class="`${index === active ? 'select-bg' : 'select-bar'}`"
            >
            </van-tab>
          </van-tabs>

          <div
            style="float: left; width: 0.15rem; margin-top: 0.06rem"
            @click="next"
          >
            <img src="../assets/mobile/right.png" alt="" style="width: 100%" />
          </div>
          <div class="clear"></div>
        </div>

        <div v-loading="loading" style="min-height: 2rem">
          <div class="text-content" v-if="type === 1">
            <div style="font-size: 26px; color: #333" class="flex-center">
              <img
                src="../assets/icon10.png"
                alt=""
                style="width: 50px; margin-right: 10px"
              />{{ basicInfo.name }}
            </div>
            <div
              style="
                margin-top: 10px;
                font-size: 16px;
                line-height: 26px;
                padding: 20px 5px 0 0;
                border-top: 1px solid #e5e5e5;
              "
              v-html="basicInfo.hospital_introduce"
            ></div>
            <div style="font-size: 20px; margin-top: 20px; color: #333">
              联系方式：
              <span style="font-size: 20px; margin-top: 10px">
                {{ basicInfo.phone }}
              </span>
            </div>

            <div style="display: flex; margin-top: 8px">
              <div style="margin-right: 10px; width: 0.6rem">地址:</div>
              <div>
                <div>{{ basicInfo.hospital_address }}</div>
                <div
                  style="font-size: 13px; margin-top: 10px"
                  v-html="basicInfo.hospital_address_way"
                ></div>
              </div>
            </div>
            <div style="font-size: 22px; margin: 30px 0 20px; color: #333">
              电子地图
            </div>
            <baidu-map
              :center="center"
              :zoom="18"
              style="height: 300px"
              :scroll-wheel-zoom="true"
            >
              <BmMarker
                :position="center"
                title="东莞黄家圣幸中医医院"
                @click="infoWindowOpen"
              >
                <bm-info-window
                  :show="show"
                  @close="infoWindowClose"
                  @open="infoWindowOpen"
                  style="font-size: 14px"
                  >东莞黄家圣幸中医医院</bm-info-window
                >
              </BmMarker>
            </baidu-map>
          </div>
          <div class="text-content" v-if="type === 2">
            <div style="line-height: 30px; padding: 0; border-radius: 10px">
              <div class="flex-center" style="padding: 10px 0">
                <img
                  src="../assets/icon4.png"
                  alt=""
                  style="width: 40px; margin-right: 20px"
                />
                <div style="font-size: 26px; color: #333">招聘信息</div>
              </div>
              <el-collapse v-model="activeNames" accordion>
                <el-collapse-item
                  v-for="(item, index) of jobList"
                  :name="index"
                  :key="index"
                >
                  <template slot="title">
                    <div
                      class="flex-center"
                      style="width: 100%; position: relative; padding: 5px 0"
                    >
                      <div style="font-size: 0.16rem; font-weight: bold">
                        {{ item.title }}
                      </div>
                    </div>
                  </template>
                  <div
                    style="margin-top: 10px; padding: 0 20px"
                    v-html="item.content"
                  ></div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <div class="text-content" v-if="type === 3">
            <div class="flex-center" style="padding: 10px 0">
              <img
                src="../assets/icon5.png"
                alt=""
                style="width: 40px; margin-right: 20px"
              />
              <div style="font-size: 26px; color: #333">在线留言</div>
            </div>
            <div
              style="
                padding-left: 5px;
                padding-right: 5px;
                font-size: 14px;
                border-top: 1px solid #e5e5e5;
                padding-top: 20px;
              "
            >
              感谢您写下宝贵留言，黄家圣幸中医医院全心为您服务！
              <div class="flex-center" style="margin-top: 30px">
                <el-input
                  v-model="form.name"
                  style="width: 100%"
                  placeholder="您的姓名"
                >
                  <template slot="prepend">
                    <img
                      src="../assets/icon6.png"
                      style="width: 15px; background: #fff"
                      alt=""
                    />
                  </template>
                </el-input>
              </div>
              <div class="flex-center" style="margin-top: 30px">
                <el-input
                  v-model="form.mobile"
                  style="width: 100%"
                  placeholder="您的联系方式"
                >
                  <template slot="prepend">
                    <img
                      src="../assets/icon7.png"
                      style="width: 15px; background: #fff"
                      alt=""
                    />
                  </template>
                </el-input>
              </div>
              <div class="flex-center" style="margin-top: 30px">
                <el-input
                  v-model="form.email"
                  style="width: 100%"
                  placeholder="您的邮箱"
                >
                  <template slot="prepend">
                    <img
                      src="../assets/icon8.png"
                      style="width: 15px; background: #fff"
                      alt=""
                    />
                  </template>
                </el-input>
              </div>
              <div style="margin-top: 30px">
                <el-input
                  type="textarea"
                  v-model="form.content"
                  style="width: 100%"
                  placeholder="您的留言"
                  :rows="4"
                ></el-input>
              </div>
              <div class="" style="margin-top: 20px">
                <verification
                  :key="verificationkey3"
                  ref="verification1"
                  style="zoom: 1; margin: 0 auto; width: 3.2rem"
                  type="mobile"
                  class="switch-Tab"
                ></verification>
                <div
                  style="
                    background: #763a27;
                    color: #fff;
                    font-size: 16px;
                    height: 40px;
                    line-height: 40px;
                    margin: 0 auto;
                    width: 3.2rem;
                    border-radius: 0;
                    text-align: center;
                    border-radius: 2px;
                    padding: 0;
                    margin-top: 20px;
                  "
                  @click="checkSubmit('phone')"
                >
                  提 交
                </div>
              </div>
            </div>
          </div>
          <div class="text-content" v-if="type === 4">
            <div
              class="flex-center"
              style="border-bottom: 1px solid #e5e5e5; padding-bottom: 10px"
            >
              <img
                src="../assets/icon9.png"
                alt=""
                style="width: 50px; margin-right: 20px"
              />
              <div style="">
                <div style="font-size: 0.24rem; color: #333">满意度调查</div>
                <div style="font-size: 0.14rem; margin-top: 10px">
                  您所给出的任何评价，都是我们日后在工作过程中最宝贵的意见，感谢您的支持！
                </div>
              </div>
            </div>
            <div
              class="question"
              v-for="(item, index) of question"
              :key="index"
            >
              <div v-if="item.type === '1'">
                <!-- 单选 -->
                <div class="questionTitle">
                  {{ index + 1 }}、{{ item.title }}
                </div>
                <div class="questionA">
                  <div v-for="(item1, indexs) of item.json" :key="indexs">
                    <el-radio
                      v-model="item.value"
                      :label="item1.title"
                      text-color="#a6937c"
                      >{{ item1.content }}</el-radio
                    >
                  </div>
                </div>
              </div>
              <div v-if="item.type === '2'">
                <div class="questionTitle" style="margin-bottom: 10px">
                  {{ index + 1 }}、{{ item.title }}
                </div>
                <!-- 多选 -->
                <el-checkbox-group v-model="item.value">
                  <el-checkbox
                    v-for="(item1, index) of item.json"
                    :label="item1.title"
                    :key="index"
                    >{{ item1.content }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div v-if="item.type === '3'">
                <div class="questionTitle" style="margin-bottom: 10px">
                  {{ index + 1 }}、{{ item.title }}
                </div>
                <!-- 文本 -->
                <el-input type="textarea" v-model="item.value"></el-input>
              </div>
            </div>
            <div class="question" style="margin-top: 20px">
              <verification
                :key="verificationkey4"
                ref="verification2"
                style="width: 3.2rem; font-size: 14px; zoom: 1; margin: 0 auto"
                type="mobile"
                class="switch-Tab"
              ></verification>
              <div
                style="
                  background: #763a27;
                  color: #fff;
                  font-size: 16px;
                  height: 40px;
                  line-height: 40px;
                  margin: 20px auto 0;
                  width: 3.2rem;
                  border-radius: 0;
                  text-align: center;
                  border-radius: 2px;
                  padding: 0;
                "
                @click="addQuestionSubmit('mobile')"
              >
                提 交
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue"; //定位
import BmMapType from "vue-baidu-map/components/controls/MapType.vue"; //地图类型
import BmCityList from "vue-baidu-map/components/controls/CityList.vue"; //城市列表
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue"; //标记点
import {
  getquestionlist,
  getmenudetail,
  getjoblist,
  addconsultation,
  addquestion,
  getsite,
} from "../api/common";
import verification from "@/components/verification";

export default {
  name: "map",
  components: {
    banner,
    footerBar,
    headerBar,
    verification,
    BmGeolocation,
    BmMapType,
    BmCityList,
    BmMarker,
  },
  data() {
    return {
      info: { carousel: "", Mcarousel: "" },
      activeNames: 0,
      activeIndex: "contact",
      type: 1,
      center: { lng: 113.662991, lat: 22.9837 },
      show: false,
      form: {
        content: "",
        name: "",
        mobile: "",
        email: "",
      },
      active: 0,
      titleList: [
        {
          main_title: "电子地图",
          type: 1,
        },
        {
          main_title: "招聘信息",
          type: 2,
        },
        {
          main_title: "在线留言",
          type: 3,
        },
        {
          main_title: "调查问卷",
          type: 4,
        },
      ],
      question: [],
      //基础信息
      basicInfo: {},
      jobList: [],
      verificationkey3: false,
      verificationkey4: false,
      verificationkey2: false,
      verificationkey1: false,
      loading: true,
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.type = this.$route.query.id;
      this.active = this.$route.query.id - 1;
      this.switchTab(this.active);
    }
    //基本信息
    getsite().then((res) => {
      this.basicInfo = res.data;
      this.loading = false;
    });
    //获取菜单详情
    getmenudetail({ id: 9 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });
  },
  methods: {
    handleSelect(index) {
      //获取招聘列表
      if (index == 2) {
        this.loading = true;
        this.jobList = []
        getjoblist().then((res) => {
          this.jobList = res.data;
          this.loading = false;
        });
      }
      //调查问卷
      if (index == 4) {
        this.loading = true;
        this.question = []
        getquestionlist().then((res) => {
          this.question = res.data;
          this.loading = false;
        });
      }
      this.type = index;
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    },
    //在线留言提交
    checkSubmit(type) {
      if (this.form.name === "") {
        this.$notify.error(`请输入您的姓名`);
        return;
      }
      if (this.form.mobile === "") {
        this.$notify.error(`请输入您的联系方式`);
        return;
      }

      if (this.form.email === "") {
        this.$notify.error(`请输入您的邮箱`);
        return;
      }
      if (this.form.content === "") {
        this.$notify.error(`请输入您的留言`);
        return;
      }
      if (type === "pc") {
        if (this.$refs.verification.confirmSuccess == false) {
          this.$notify.error(`请完成拖动滑块验证`);
          return;
        }
      }
      if (type === "mobile") {
        if (this.$refs.verification1.confirmSuccess == false) {
          this.$notify.error(`请完成拖动滑块验证`);
          return;
        }
      }
      addconsultation(this.form).then((res) => {
        this.verificationkey2 = !this.verificationkey2;
        this.verificationkey3 = !this.verificationkey3;
        this.form = {
          content: "",
          name: "",
          mobile: "",
          email: "",
        };
        if (res.code == 1) {
          this.$notify({
            type: "success",
            message: res.msg,
          });
        } else {
          this.$notify({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //调查问卷
    addQuestionSubmit(type) {
      var questionlist = this.question;
      for (let i = 0; i < questionlist.length; i++) {
        if (questionlist[i].type == 3) {
          if (questionlist[i].value == null) {
            this.$notify.error(`请填写内容再进行提交`);
            return;
          }
        } else {
          if (questionlist[i].value == null) {
            this.$notify.error(`请选择完整再进行提交`);
            return;
          }
        }
      }
      if (type === "pc") {
        if (this.$refs.verification.confirmSuccess == false) {
          this.$notify.error(`请完成拖动滑块验证`);
          return;
        }
      }
      if (type === "mobile") {
        if (this.$refs.verification2.confirmSuccess == false) {
          this.$notify.error(`请完成拖动滑块验证`);
          return;
        }
      }
      addquestion({ cuestioncollectdetaillist: questionlist }).then((res) => {
        this.verificationkey1 = !this.verificationkey1;
        this.verificationkey4 = !this.verificationkey4;
        if (res.code == 1) {
          this.$notify({
            type: "success",
            message: res.msg,
          });
          getquestionlist().then((res) => {
            this.question = res.data;
          });
        } else {
          this.$notify({
            type: "error",
            message: res.msg,
          });
        }
      });
    },

    // 手机端js

    switchTab(name, title) {
      this.type = name + 1;
      this.handleSelect(this.type);
    },

    last() {
      if (this.active !== 0) {
        this.active--;
        this.type = this.active + 1;
        this.handleSelect(this.type);
      }
    },
    next() {
      if (this.active !== this.titleList.length - 1) {
        this.active++;
        this.type = this.active + 1;
        this.handleSelect(this.type);
        console.log(this.active, this.type);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.map {
  background: #f3f3f3;
}
.map .selectBar {
  background: #439392;
  color: #fff;
  padding: 10px 0;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}
.map .no-selectBar {
  padding: 10px 0;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}
.map .no-selectBar:hover {
  background: #fff;
  color: #333;
  padding: 10px 0;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}
.map .text-content {
  flex: 1;
  background: #fff;
  padding: 20px 40px;
  font-family: "Microsoft YaHei";
}
.map .el-collapse-item__header {
  height: auto !important;
  line-height: 24px !important;
  padding: 10px !important;
  border-bottom: 0;
  background: none !important;
}
.map .el-collapse-item__wrap {
  background: none !important;
}
.map .el-input-group__prepend {
  background: #fff;
  padding: 0 15px;
}
.map .question {
  padding: 0 10px;
  margin-top: 20px;
}
.map .question .questionTitle {
  margin-top: 20px;
}
.map .question .questionA {
  margin-top: 10px;
}
.map .question .questionA > div {
  margin-top: 6px;
}
.map .question .el-radio__input.is-checked .el-radio__inner,
.map .question .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #439392;
  background: #439392;
}
.map .question .el-radio__input.is-checked + .el-radio__label {
  color: #439392;
}
.map .question .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #439392;
}
.map .el-collapse-item__content {
  font-size: 16px;
  color: #444;
}
.map .el-collapse-item__header {
  color: #333;
}

@media screen and (max-width: 750px) {
  .map .mobile .text-content {
    padding: 10px 10px;
    font-family: "Microsoft YaHei";
    zoom: 0.9;
  }
  .map .mobile .questionTitle {
    font-size: 0.18rem;
  }
  .map .question .el-radio__input.is-checked .el-radio__inner,
  .map .question .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #763a27;
    background: #763a27;
  }
  .map .question .el-radio__input.is-checked + .el-radio__label {
    color: #763a27;
  }
  .map .question .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #763a27;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contact.vue